// export const privacyScroll = () => {
//   const privacyBox = document.querySelector(".js-privacy-box");
//   const checkboxWrap = document.querySelector(".js-privacy-checkbox");

//   if (!privacyBox || !checkboxWrap) return;

//   const checkbox = checkboxWrap.querySelector('input[type="checkbox"]');
//   if (!checkbox) return;

//   privacyBox.addEventListener("scroll", () => {
//     // スクロール位置が最下部に近いかを判定（5pxの余裕を持たせる）
//     const isAtBottom =
//       privacyBox.scrollTop + privacyBox.clientHeight >=
//       privacyBox.scrollHeight - 5;

//     if (isAtBottom) {
//       checkbox.disabled = false;
//       checkboxWrap.classList.remove("_disabled");
//     }
//   });
// };


export const privacyScroll = () => {
  const privacyBox = document.querySelector(".js-privacy-box");
  const checkboxWrap = document.querySelector(".js-privacy-checkbox");

  if (!privacyBox || !checkboxWrap) return;

  const checkbox = checkboxWrap.querySelector('input[type="checkbox"]');
  if (!checkbox) return;

  // 【追加】初期状態でチェックボックスを無効化し、スタイルを適用
  checkbox.disabled = true;
  checkboxWrap.classList.add("_disabled");

  privacyBox.addEventListener("scroll", () => {
    // スクロール位置が最下部に達したかを判定（誤差を考慮して5pxの余裕）
    const isAtBottom =
      privacyBox.scrollTop + privacyBox.clientHeight >=
      privacyBox.scrollHeight - 5;

    if (isAtBottom) {
      // 無効化を解除
      checkbox.disabled = false;
      checkboxWrap.classList.remove("_disabled");
      
      // 一度最下部に達したら、スクロールイベントを削除して負荷を軽減（任意）
      // privacyBox.removeEventListener("scroll", arguments.callee);
    }
  });
};